import React, { useEffect, useState } from "react";
import logo from "../../Assets/home/BestPlansimg.png";
import rightlogo from "../../Assets/home/rightlogo.png";
import axios from 'axios';

const BestPlans = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true); // Track loading state

  const getAllPlans = () => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_KEY}/plans/getAllPlansByBranchId/674586f39aa6780fb2688685`,
      headers: {}
    };

    axios.request(config)
      .then((response) => {
        setPlans(response.data);
        setLoading(false); // Stop loading after data is fetched
      })
      .catch((error) => {
        console.log(error);
        setLoading(false); // Stop loading if there is an error
      });
  };

  useEffect(() => {
    getAllPlans();
  }, []);

  const handleBookNow = (plan) => {
    const phoneNumber = '917327986868'; // Replace with your phone number including country code
    const message = `Hello, I would like to book an appointment with you. Plan: ${plan?.type}. Price: ₹ ${plan?.price}.`;

    // URL encode the message to make sure it's formatted correctly
    const encodedMessage = encodeURIComponent(message);

    // Open WhatsApp with pre-filled message
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

    // Open the WhatsApp chat
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="bg-white text-center py-4 md:py-10 mx-6 md:mx-16">
      <div className="text-[#ff6a00] mb-2 text-lg italic">Best Plans</div>
      <h1 className="text-3xl md:text-5xl font-serif font-semibold text-[#202020] leading-tight md:leading-tight">
        Provide Best And Relaxing Service <br />
        With Best Pricing Plans
      </h1>

      <div className="grid grid-cols-1 lg:grid-cols-3 justify-center space-y-6 mt-10 lg:space-y-0 lg:space-x-6">
        {loading ? (
          Array.from({ length: 3 }).map((_, index) => <SkeletonLoader key={index} />)
        ) : (
          plans.map((plan, index) => (
            <div
              key={plan.id}
              className="bg-white hover:bg-[#FFEFEA] hover:scale-105 p-6 rounded-lg shadow-lg border border-[#ff6a00]"
              data-aos={index % 2 === 0 ? "fade-down" : "fade-up"} // Alternate AOS animation
            >
              <div className="flex justify-center mb-4">
                <img src={logo} alt="Service logo" />
              </div>
              <h2 className="text-3xl font-bold text-[#2C2A2A] mb-8 font-serif">
                {plan.type}
              </h2>
              <hr className="border-2 border-[#ff6a00] mb-8" />
              <ul className="xl:ml-16 space-y-5 mb-6 text-start">
                {plan.keyPoints.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center mb-2">
                    <img src={rightlogo} alt="check icon" className="mr-2" />
                    {feature}
                  </li>
                ))}
              </ul>
              <div className="text-3xl font-bold text-[#434242] mb-8 font-sans">
                <span>₹</span>{plan.price} <span className="text-xl font-normal">/Per Day</span>
              </div>
              <button className="py-3 px-12 text-white font-semibold bg-[#ff6a00] rounded">
                Book Now
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default BestPlans;

// Skeleton loader component
function SkeletonLoader() {
  return (
    <div className="bg-white p-6 rounded-lg shadow-lg border border-[#ff6a00] animate-pulse">
      <div className="flex justify-center mb-4">
        <div className="w-24 h-24 bg-gray-300 rounded-full mx-auto"></div>
      </div>
      <div className="h-6 w-32 bg-gray-300 rounded mb-4 mx-auto"></div>
      <div className="h-4 w-1/2 bg-gray-300 rounded mb-4 mx-auto"></div>
      <div className="h-4 w-2/3 bg-gray-300 rounded mb-4 mx-auto"></div>
      <div className="h-4 w-3/4 bg-gray-300 rounded mb-4 mx-auto"></div>
      <div className="text-3xl font-bold text-[#434242] mb-8 font-sans">
        
      </div>
      <div className="h-10 w-32 bg-[#ff6a00] rounded mx-auto"></div>
    </div>
  );
}
